var map = {
	"./childCare.svg": 4756,
	"./fqhc.svg": 4195,
	"./groceryStores.svg": 3922,
	"./hospitals.svg": 7024,
	"./mentalHealthCareFacilities.svg": 1070,
	"./obgynPhysicianFacilities.svg": 5189,
	"./pharmacies.svg": 5480,
	"./urgentCare.svg": 491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8143;